import React, { Suspense, lazy } from 'react';

import { DailyForecastListLoadingUI } from './loadingUI/dailyForecastListLoadingUI';

const DailyForecastWrapper = lazy(() => import('./dailyForecastWrapper'));

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const DailyForecastWrapperLazy = () => {
    return (
        <Suspense fallback={<DailyForecastListLoadingUI />}>
            <DailyForecastWrapper />
        </Suspense>
    );
};